import type { ReactNode } from "react";

import { Badge } from "@/shared/ui/badge";
import { cn } from "@/shared/lib/utils";

import type { DomainTone } from "../../model/domainStatus";

const TONE_CLASS: Record<DomainTone, string> = {
  ok: "border-success/50 bg-success/10 text-success",
  warn: "border-warning/60 bg-warning/10 text-warning",
  error: "border-destructive/50 bg-destructive/10 text-destructive",
  muted: "border-border text-muted-foreground",
};

/** 屏 5 的状态徽标(域名状态 / DNS 记录状态 / 预览域名「已生效」):outline Badge + 皮肤 token 上色。 */
export function ToneBadge({
  tone,
  children,
  className,
}: {
  tone: DomainTone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Badge
      variant="outline"
      data-tone={tone}
      className={cn("normal-case tracking-normal", TONE_CLASS[tone], className)}
    >
      {children}
    </Badge>
  );
}
